import React from 'react';
import {usePaymentContext} from "../../contexts/PaymentContext";
import {usePaymentPaypalContext} from '../../contexts/PaymentPaypalContext';
import InputInvoice from '../InputInvoice';

const FieldInvoicePaypal = () => {
  const {loadInvoiceOptions, onInvoiceChanged, updateForm} = usePaymentPaypalContext();
  const {invoiceOrder} = usePaymentContext();

  return (
    <InputInvoice
      loadInvoiceOptions={loadInvoiceOptions}
      onInvoiceChanged={onInvoiceChanged}
      updateForm={updateForm}
      invoiceOrder={invoiceOrder}
    />
  );
};

export default FieldInvoicePaypal;
